import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOATangibleProperty() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ tangibleProperty, setTangibleProperty ] = useState(powerOfAttorney.tangible_personal_property || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../real-estate');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      tangible_personal_property: tangibleProperty
    }));
    navigate('../digital-assets');
  }, [ tangibleProperty, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-tangible-property screen-container screen">
      <ScreenHeader
        title="Tangible Personal Property Transactions"
        description="Decide whether to grant your agent power over your personal belongings"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Tangible Personal Property Powers?</h3>
        <p>
          Tangible personal property includes all your physical belongings that are not real estate, such as:
        </p>
        <ul className="property-list">
          <li>Furniture and household items</li>
          <li>Jewelry and collectibles</li>
          <li>Artwork and antiques</li>
          <li>Vehicles and boats</li>
          <li>Electronics and equipment</li>
          <li>Clothing and personal effects</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Buy, sell, or trade your personal property</li>
          <li>Donate items to charity</li>
          <li>Store or move your belongings</li>
          <li>Insure your valuable items</li>
          <li>Handle repairs and maintenance</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="tangible-property-yes"
            label="Yes"
            description="Grant power over tangible personal property"
            value="yes"
          />
          <AssetDistributionOption
            id="tangible-property-no"
            label="No"
            description="Do not grant power over tangible personal property"
            value="no"
          />
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
